import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-eye\"><defs><style type=\"text/css\"></style></defs><path d=\"M516.608 414.141c-62.48 0-117.15 50.765-117.15 117.151 0 62.48 50.764 117.15 117.15 117.15s117.15-50.764 117.15-117.15-54.67-117.15-117.15-117.15z m-3.907-156.195c-195.246 0-367.068 93.721-472.499 265.538 109.338 171.817 281.16 281.16 472.5 281.16 195.246 0 367.068-113.244 472.499-285.061C879.77 347.76 707.948 257.946 512.7 257.946z m3.907 468.592c-109.338 0-199.153-89.815-199.153-199.152s89.81-199.153 199.153-199.153 195.246 93.722 195.246 203.06-85.908 195.245-195.246 195.245z\" p-id=\"3842\" fill=\"#657180\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icon/svg/eye.svg
// module id = bDKe
// module chunks = 24